module.exports = "/_next/static/files/2e1b23efbe5552885aece1f6eb3e76b4.png";